import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Field } from 'formik';
import styles from './styles.FormFieldRadioGroup';
import { useTranslation } from 'react-i18next';

const RADIO_STYLES = {
  scale: styles.scale,
  fill: styles.fill,
  normal: styles.normal,
  stars: styles.stars,
  vertical: styles.vertical,
};

const getStyle = (style) => RADIO_STYLES[style] || RADIO_STYLES.normal;

export default function FormFieldRadioGroup({
  field: { name, value },
  question,
  context,
  disabled,
  ...props
}) {
  const { options, style } = question.config;
  const { t } = useTranslation();
  return (
    (options && (
      <div
        className={cx(styles.optionGroup, getStyle(style), {
          [styles.dimmer]: disabled,
        })}
        data-value={value}
      >
        {options.map((option, index) => {
          const key = `${name}--${index}`;
          const checked = value && value == option.value; // Not strict === because 1 !== "1"
          return (
            <div key={key} className={cx(styles.option)}>
              <Field
                type="radio"
                id={key}
                name={name}
                value={option.value}
                checked={checked}
                className={styles.optionInput}
                disabled={disabled}
              />
              <label
                className={cx(styles.optionLabel, {
                  [styles.disabledField]: disabled,
                })}
                htmlFor={key}
              >
                <div className={styles.optionLabelText}>{t(option.label)}</div>
              </label>
            </div>
          );
        })}
      </div>
    )) ||
    null
  );
}

FormFieldRadioGroup.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
};
